/*
jQuery dynamicFontSize v1.0.0, April 2017 - Panagiotis Iakovakis

Usage:

$("#div").dynamicFontSize({
	maximumFontSize: {Number}, (60)
	minimumFontSize: {Number}, (1)
	horizontalAlign: {String}, ("left")
	verticalAlign: {String}, ("top")
	wordBreak: {String}, (null)
});

Divs that are going to be used to calculate font-size, need:
- this attribute (data-dynamic-font-size) set to "true": data-dynamic-font-size="true"
- <optional> data-dynamic-text-options="..."  <- the available options are below

Options:

maximumFontSize: Maximum font size of the text. (a number in pixels), default value `60`

minimumFontSize: MinimumFontSize font size of the text. (a number in pixels), default value `1`

horizontalAlign: Horizontal alignment of text. ("left","center","right"), default value `left`

verticalAlign: Vertical alignment of text. ("top","middle","bottom"), default value `top`

wordBreak: Break words/letters if width of text is bigger than the container, default value `null` (not set at all)
"normal" 	Break words according to their usual rules
"break-all" Lines may break between any two letters
"keep-all"  Breaks are prohibited between pairs of letters
"initial" 	Sets this property to its default value. Read about initial
"inherit" 	Inherits this property from its parent element. Read about inherit

*/


(function($){
    "use strict";
    var defaultOptions= {
        maximumFontSize: 60,
        horizontalAlign: "left",
        verticalAlign: "top",
        wordBreak: null
    };

    $.fn.dynamicFontSize= function(options) {
        return this.each(function() {
            options= $.extend({}, defaultOptions, options);

            var $this= $(this);
            var $parent= $this.parent();
            var textCharacters = $this.text();
            var initialFontSize = 1;

            if(!$this.text() || $this.text().trim().length == 0) { return; }

            var $newSpan = $("<span />");
            var parentWidth = $parent.width() - 10; //subtract some pixels to avoid text overflow, and text-ellipsis effect to appear
            var parentHeight = $parent.height();

            //hides the element to prevent "flashing"
            $this.css("visibility", "hidden");

            $newSpan.css("font-size", initialFontSize+"px");
            $newSpan.text(textCharacters);
            $("body").append($newSpan);
            var spanTextWidth = $newSpan.width();
            var spanTextHeight = $newSpan.height();

            var ratioWidth = parentWidth / spanTextWidth;
            var finalFontSize = initialFontSize * ratioWidth;

            finalFontSize = finalFontSize > options.maximumFontSize ? options.maximumFontSize : finalFontSize; //check for maximumFontSize
            finalFontSize = finalFontSize < options.minimumFontSize ? options.minimumFontSize : finalFontSize;


            //recalculate width and ratio of the span, with the new font-size now, to have a better font-size value for long texts
            /*  explanation of the recalculation--> text: "45 Event Road Str, Greek, Kapela, Aegean"
            * the firstly calculated "finalFontSize" for a parent with "280px" width, is: 11.7px
            * the second one (re-calculation) is: 15.7px
            * which fills more of the current element's width
            */

            $newSpan.css("font-size", finalFontSize+"px");
            var newSpanTextWidth = $newSpan.width();
            var newRatioWidth = parentWidth / newSpanTextWidth;
            var newFontSize = finalFontSize * newRatioWidth;

            $newSpan.remove(); //remove it, since we no longer need it.
            finalFontSize = Math.floor(finalFontSize * newRatioWidth);
            finalFontSize = finalFontSize > options.maximumFontSize ? options.maximumFontSize : finalFontSize; //check for maximumFontSize
            finalFontSize = finalFontSize < options.minimumFontSize ? options.minimumFontSize : finalFontSize;


            var lineHeight;
            switch(options.verticalAlign.toLowerCase()) {
                case "middle":
                    lineHeight = spanTextHeight / parentHeight >= 1 ? spanTextHeight / parentHeight : 1;
                    break;
                case "bottom":
                    lineHeight = (spanTextHeight / parentHeight >= 1 ? spanTextHeight / parentHeight : 1) * (3/2);
                    break;
                default: //top
                    lineHeight = 1;
            }

            var endCSS = {};
            switch(options.horizontalAlign.toLowerCase()) {
                case "left":
                    endCSS['left']= "0%";
                break;
                case "right":
                    endCSS['left']= "100%";
                    endCSS['margin-left']= Math.floor(-$this.innerWidth()) + "px";
                break;
                default:
                    endCSS['margin-left']= Math.floor((-$this.innerWidth() / 2)) + "px";
                break;
            }
            if(options.wordBreak) {
                endCSS['word-break']= options.wordBreak;
            }

            $this.css({
                'display': 'inline-block',
                'font-size': finalFontSize + 'px',
                'text-align': options.horizontalAlign,
                'line-height': lineHeight
            });

            $this.css(endCSS);
            //shows the element after the work is done
            $this.css("visibility", "visible");
        });
    }
})(jQuery);